import { RouteObject } from 'react-router';

import { CustomersPageLazy } from './page.tsx';

import { RoleProtectedRoute } from '@/services/roles/components/role-protected-route/view.tsx';
import { EAdminRoutes } from '@/services/router/enums';

export const CUSTOMERS_ROUTE: RouteObject = {
    path: EAdminRoutes.Customers,
    element: (
        <RoleProtectedRoute path={EAdminRoutes.Customers}>
            <CustomersPageLazy />
        </RoleProtectedRoute>
    ),
};
